import {Component} from '@angular/core';
import {IBaseComponent} from '../ibase/ibase.component';

/**
 * Base page component
 */
@Component({
    selector: 'app-ibase-page',
    template: ''
})
export abstract class IBasePageComponent extends IBaseComponent {}
